export const storySets =[
    {
        "setNumber": 1,
        "title": "मिलो बंदर सीखता गणित",
        "story": "मिलो नाम का बंदर हमेशा नई चीजें सीखने के लिए उत्साहित रहता था, खासकर गणित। उसने अपने लर्निंग सेंटर में गणित की किताबों का उपयोग किया, जिससे उसे मुश्किल अवधारणाओं को समझने में आसानी हुई। मिलो को अपने दोस्तों के साथ सीखना पसंद था क्योंकि वे एक-दूसरे की मदद कर सकते थे, जिससे यह प्रक्रिया मजेदार और सहयोगी बन जाती थी। जब मिलो को कोई कठिन समस्या आती, तो उसका शिक्षक हमेशा उसे ऐसी भाषा में समझाता जो उसे समझ में आ जाए। इस समर्थन ने मिलो को आत्म-विश्वास और सीखने के प्रति उत्साह बढ़ाया। एक दिन, मिलो का दोस्त बेनी, जो भालू था, गणित की समस्या से जूझ रहा था और हताश महसूस कर रहा था। मिलो ने याद किया कि उसके शिक्षक ने उसकी कैसे मदद की थी और उसने बेनी को अपनी ज्ञान साझा करने का फैसला किया। मिलकर काम करने से वे दोनों ने समस्या हल कर दी और अपनी टीमवर्क पर गर्व महसूस किया। मिलो के अनुभव ने उसे सिखाया कि सीखना सिर्फ अच्छे अंक पाने के बारे में नहीं है बल्कि एक-दूसरे की मदद करने और साथ में बढ़ने के बारे में भी है।",
        "lifeLessons": [
          { "title": "Teamwork (टीमवर्क)", "description": "दोस्तों के साथ सीखने से कठिन विषयों को आसान और मजेदार बनाया जा सकता है।" },
          { "title": "Support (समर्थन)", "description": "दूसरों की मदद करने से आपसी विकास और मजबूत संबंध बन सकते हैं।" },
          { "title": "Confidence (आत्म-विश्वास)", "description": "सीखने और समर्थन के माध्यम से आत्म-विश्वास प्राप्त करना लोगों को चुनौतियों को पार करने के लिए सक्षम बनाता है।" }
        ],
        "questions": [
          {
            "id": 1,
            "text": "मिलो बंदर गणित की किताबों का उपयोग कैसे करता है? क्या आप कोई ऐसा समय साझा कर सकते हैं जब आपने गणित की किताब का उपयोग स्कूल के काम में मदद के लिए किया हो?",
            "options": [
              { "value": "A", "text": "यह गणित को कठिन बना देता है।" },
              { "value": "B", "text": "यह गणित को आसान बना देता है।" },
              { "value": "C", "text": "यह गणित को भ्रमित करता है।" },
              { "value": "D", "text": "यह गणित को बोरिंग बना देता है।" }
            ]
          },
          {
            "id": 2,
            "text": "मिलो को अपने दोस्तों के साथ सीखना पसंद है। आप कितनी बार अपने दोस्तों के साथ सेंटर पर जाते हैं, और इससे आपको बेहतर सीखने में कैसे मदद मिलती है?",
            "options": [
              { "value": "A", "text": "कभी नहीं।" },
              { "value": "B", "text": "कभी-कभी।" },
              { "value": "C", "text": "हमेशा।" },
              { "value": "D", "text": "केवल एक बार।" }
            ]
          },
          {
            "id": 3,
            "text": "यदि मिलो के पास एक विशेष लर्निंग किट होती, तो यह उसे स्कूल के विषयों में कैसे मदद करती?",
            "options": [
              { "value": "A", "text": "यह सीखने को मजेदार बनाती।" },
              { "value": "B", "text": "यह सीखने को बोरिंग बनाती।" },
              { "value": "C", "text": "यह सीखने को कठिन बनाती।" },
              { "value": "D", "text": "यह सीखने को भ्रमित करती।" }
            ]
          },
          {
            "id": 4,
            "text": "मिलो को जब वह अटका होता है, तो उसका शिक्षक उसे मदद करता है। आपके शिक्षक ने आपके स्कूल के काम में कैसे मदद की है?",
            "options": [
              { "value": "A", "text": "अनदेखा करके।" },
              { "value": "B", "text": "स्पष्ट रूप से समझा कर।" },
              { "value": "C", "text": "इसे कठिन बनाकर।" },
              { "value": "D", "text": "मुझे बुरा महसूस कराकर।" }
            ]
          },
          {
            "id": 5,
            "text": "मिलो नए चीजें सीखने के बाद आत्म-विश्वास महसूस करता है। क्या आपको सेंटर पर आने के बाद स्कूल के बारे में अधिक आत्म-विश्वास महसूस होता है? क्या आप बता सकते हैं कैसे?",
            "options": [
              { "value": "A", "text": "नहीं, मैं कम आत्म-विश्वास महसूस करता हूँ।" },
              { "value": "B", "text": "हाँ, मैं अधिक आत्म-विश्वास महसूस करता हूँ।" },
              { "value": "C", "text": "मैं वैसे ही महसूस करता हूँ।" },
              { "value": "D", "text": "मुझे नहीं पता।" }
            ]
          },
          {
            "id": 6,
            "text": "मिलो और उसके दोस्त शैक्षिक खेल खेलते हैं। क्या आपने सेंटर पर कोई ऐसा खेल खेला है जिससे सीखना मजेदार हो गया?",
            "options": [
              { "value": "A", "text": "नहीं, मैंने कोई खेल नहीं खेला।" },
              { "value": "B", "text": "हाँ, और उन्होंने सीखना मजेदार बना दिया।" },
              { "value": "C", "text": "हाँ, लेकिन वे बोरिंग थे।" },
              { "value": "D", "text": "नहीं, खेल भ्रमित करने वाले थे।" }
            ]
          },
          {
            "id": 7,
            "text": "मिलो के पास पढ़ाई के लिए एक शांत स्थान है। सेंटर पर पढ़ाई घर से कैसे अलग है?",
            "options": [
              { "value": "A", "text": "यह अधिक शोरगुल है।" },
              { "value": "B", "text": "यह अधिक ध्यान भंग करने वाला है।" },
              { "value": "C", "text": "यह शांत और केंद्रित है।" },
              { "value": "D", "text": "यह कम संगठित है।" }
            ]
          },
          {
            "id": 8,
            "text": "मिलो अपने नए दोस्तों के साथ गणित का अभ्यास करता है। क्या आपने गणित में सुधार होते हुए महसूस किया है? क्या आप कोई उदाहरण दे सकते हैं?",
            "options": [
              { "value": "A", "text": "नहीं, मैंने सुधार नहीं किया।" },
              { "value": "B", "text": "हाँ, मैंने सुधार किया है।" },
              { "value": "C", "text": "मुझे यकीन नहीं है।" },
              { "value": "D", "text": "मैं गणित में अब खराब हूँ।" }
            ]
          },
          {
            "id": 9,
            "text": "मिलो बेहतर सोचने के लिए शतरंज खेलता है। क्या आपने सेंटर पर शतरंज या अन्य खेल खेले हैं? क्या आपको लगता है कि वे आपकी मदद करते हैं?",
            "options": [
              { "value": "A", "text": "नहीं, मैंने कोई खेल नहीं खेला।" },
              { "value": "B", "text": "हाँ, और उन्होंने मुझे बेहतर सोचने में मदद की।" },
              { "value": "C", "text": "हाँ, लेकिन वे भ्रमित करने वाले थे।" },
              { "value": "D", "text": "नहीं, खेल उपयोगी नहीं थे।" }
            ]
          },
          {
            "id": 10,
            "text": "मिलो का पसंदीदा विषय विज्ञान है। सेंटर पर आपका पसंदीदा विषय क्या है, और क्यों?",
            "options": [
              { "value": "A", "text": "मेरा कोई पसंदीदा विषय नहीं है।" },
              { "value": "B", "text": "मेरा पसंदीदा विषय गणित है क्योंकि यह मजेदार है।" },
              { "value": "C", "text": "मेरा पसंदीदा विषय विज्ञान है क्योंकि यह दिलचस्प है।" },
              { "value": "D", "text": "मेरा पसंदीदा विषय कला है क्योंकि यह रचनात्मक है।" }
            ]
          }
        ]
      },
      {
        "setNumber": 2,
        "title": "लूसी शेरनी और स्कूल का वातावरण",
        "story": `लूसी नाम की शेरनी को अपने लर्निंग सेंटर में जाना बहुत पसंद था क्योंकि वहाँ पढ़ने के लिए मजेदार किताबें और एक बेहतरीन अध्ययन का वातावरण था। उसे विशेष लर्निंग किट्स और डिजिटल टूल्स की सराहना थी जो सीखने को अधिक इंटरैक्टिव और मजेदार बनाते थे। जब लूसी को पढ़ाई या लेखन में कठिनाइयाँ आतीं, तो उसका शिक्षक हमेशा धैर्यपूर्वक मदद करता और सुनिश्चित करता कि लूसी सामग्री को समझ सके। 
      एक दिन, लूसी ने देखा कि उसका दोस्त, टिम्मी कछुआ, एक पढ़ाई के असाइनमेंट में परेशानी में था और निराश महसूस कर रहा था। लूसी ने याद किया कि उसके शिक्षक ने उसकी कैसे मदद की थी और उसने टिम्मी को समर्थन देने का फैसला किया। उसने टिम्मी के साथ बैठकर डिजिटल टूल्स का उपयोग किया और पढ़ाई को अधिक आकर्षक बना दिया। जल्द ही टिम्मी आत्म-विश्वास महसूस करने लगा। लूसी के इस दयालु कार्य ने न केवल टिम्मी की मदद की बल्कि उसे एक सहायक दोस्त होने का महत्व भी समझाया।`,
        "lifeLessons": [
          { "title": "Patience", "description": "धैर्य: शिक्षक और दोस्त कठिन विषयों को समझने में मदद कर सकते हैं।" },
          { "title": "Kindness", "description": "दयालुता: दूसरों की मदद करने से उनके सीखने के अनुभव में बड़ा अंतर आ सकता है।" },
          { "title": "Gratitude", "description": "आभार: उपलब्ध संसाधनों और समर्थन की सराहना करना सीखने की प्रक्रिया को बढ़ा सकता है।" }
        ],
        "questions": [
          {
            "id": 1,
            "text": "लूसी शेरनी अपने लर्निंग सेंटर में किताबें पढ़ना पसंद करती है। सेंटर से आपकी पसंदीदा किताब कौन सी है, और आपको क्यों पसंद है?",
            "options": [
              { "value": "A", "text": "मुझे कोई किताब पसंद नहीं है।" },
              { "value": "B", "text": "मेरी पसंदीदा किताब एक कहानी की किताब है।" },
              { "value": "C", "text": "मेरी पसंदीदा किताब एक कॉमिक बुक है।" },
              { "value": "D", "text": "मेरी पसंदीदा किताब एक चित्र पुस्तक है।" }
            ]
          },
          {
            "id": 2,
            "text": "लूसी अपने अध्ययन के टेबल को देखकर उत्साहित होती है। सेंटर पर आपकी अध्ययन की जगह के बारे में आप कैसा महसूस करते हैं?",
            "options": [
              { "value": "A", "text": "मुझे यह पसंद नहीं है।" },
              { "value": "B", "text": "मैं इसके बारे में खुश महसूस करता हूँ।" },
              { "value": "C", "text": "मैं बोर महसूस करता हूँ।" },
              { "value": "D", "text": "मुझे कोई फर्क नहीं पड़ता।" }
            ]
          },
          {
            "id": 3,
            "text": "लूसी को कभी-कभी अपने शिक्षक से अतिरिक्त मदद की ज़रूरत होती है। आपके शिक्षक कठिन विषयों में आपकी कैसे मदद करते हैं?",
            "options": [
              { "value": "A", "text": "मुझे अनदेखा करके।" },
              { "value": "B", "text": "स्पष्ट रूप से समझाकर।" },
              { "value": "C", "text": "इसे कठिन बनाकर।" },
              { "value": "D", "text": "मुझे बुरा महसूस कराकर।" }
            ]
          },
          {
            "id": 4,
            "text": "लूसी और उसके दोस्त डिजिटल डिवाइस का उपयोग करके सीखते हैं। क्या आपने सेंटर पर कोई डिजिटल टूल्स का उपयोग किया है?",
            "options": [
              { "value": "A", "text": "नहीं, मैंने कोई डिजिटल टूल्स का उपयोग नहीं किया।" },
              { "value": "B", "text": "हाँ, और उन्होंने मेरी मदद की।" },
              { "value": "C", "text": "हाँ, लेकिन वे भ्रमित करने वाले थे।" },
              { "value": "D", "text": "नहीं, वे उपयोगी नहीं थे।" }
            ]
          },
          {
            "id": 5,
            "text": "लूसी विशेष लर्निंग किट्स का उपयोग करती है। क्या आपने कोई लर्निंग किट्स का उपयोग किया है, और क्या वे आपकी स्कूल की पढ़ाई में मददगार साबित हुई हैं?",
            "options": [
              { "value": "A", "text": "नहीं, मैंने कोई किट्स का उपयोग नहीं किया।" },
              { "value": "B", "text": "हाँ, और वे मददगार थीं।" },
              { "value": "C", "text": "हाँ, लेकिन वे भ्रमित करने वाली थीं।" },
              { "value": "D", "text": "नहीं, वे मददगार नहीं थीं।" }
            ]
          },
          {
            "id": 6,
            "text": "लूसी और उसके दोस्त गणित का अभ्यास करते हैं। सेंटर पर दोस्तों के साथ सीखने से आपकी समझ बेहतर कैसे होती है?",
            "options": [
              { "value": "A", "text": "यह सीखने को कठिन बना देता है।" },
              { "value": "B", "text": "यह सीखने को और मजेदार बना देता है।" },
              { "value": "C", "text": "यह सीखने को बोरिंग बना देता है।" },
              { "value": "D", "text": "यह सीखने को भ्रमित करता है।" }
            ]
          },
          {
            "id": 7,
            "text": "लूसी नए चीजें सीखने के बाद खुश महसूस करती है। क्या आप सेंटर पर नई चीजें सीखने के बाद खुश महसूस करते हैं?",
            "options": [
              { "value": "A", "text": "नहीं, मैं दुखी महसूस करता हूँ।" },
              { "value": "B", "text": "हाँ, मैं खुश महसूस करता हूँ।" },
              { "value": "C", "text": "मैं वैसे ही महसूस करता हूँ।" },
              { "value": "D", "text": "मुझे निराशा महसूस होती है।" }
            ]
          },
          {
            "id": 8,
            "text": "लूसी और उसके दोस्त खेल खेलते हैं ताकि बेहतर सीख सकें। सेंटर पर आपने कौन-कौन से खेल खेले हैं, और क्या वे आपकी पढ़ाई में मदद करते हैं?",
            "options": [
              { "value": "A", "text": "मैंने कोई खेल नहीं खेले।" },
              { "value": "B", "text": "मैंने खेल खेले और वे मददगार थे।" },
              { "value": "C", "text": "मैंने खेल खेले, लेकिन वे भ्रमित करने वाले थे।" },
              { "value": "D", "text": "नहीं, खेल उपयोगी नहीं थे।" }
            ]
          },
          {
            "id": 9,
            "text": "लूसी का पसंदीदा विषय विज्ञान है। सेंटर पर आपका पसंदीदा विषय क्या है, और क्यों?",
            "options": [
              { "value": "A", "text": "मेरा कोई पसंदीदा विषय नहीं है।" },
              { "value": "B", "text": "मेरा पसंदीदा विषय गणित है क्योंकि यह मजेदार है।" },
              { "value": "C", "text": "मेरा पसंदीदा विषय विज्ञान है क्योंकि यह दिलचस्प है।" },
              { "value": "D", "text": "मेरा पसंदीदा विषय कला है क्योंकि यह रचनात्मक है।" }
            ]
          }
        ]
      },
      {
        "setNumber": 3,
        "title": "Confidence and Skills",
        "story": "सैमी नाम की गिलहरी एक मेहनती छात्रा थी जो रोज़ पढ़ाई और लेखन का अभ्यास करती थी। उसके शिक्षक ने उसे विशेष किट्स का उपयोग करने के लिए प्रोत्साहित किया ताकि वह विभिन्न विषयों को बेहतर समझ सके। सैमी ने अपनी प्रगति पर गर्व महसूस किया और जो कुछ भी सीखा था, उसे अपने परिवार और दोस्तों के साथ साझा करना पसंद किया। एक दिन, सैमी की दोस्त, रोज़ी खरगोश, अपनी लेखन क्षमताओं में परेशानी महसूस कर रही थी और निराश हो रही थी। सैमी ने याद किया कि उसके शिक्षक ने उसकी कैसे मदद की थी और उसने रोज़ी की सहायता करने का निर्णय लिया। उसने अपनी विशेष किट्स साझा की और रोज़ी को प्रभावी तरीके से अभ्यास करने का तरीका दिखाया। सैमी की मदद से, रोज़ी ने अपनी लेखन क्षमताओं में सुधार किया और आत्म-विश्वास प्राप्त किया। सैमी ने सीखा कि सच्ची सफलता केवल व्यक्तिगत उपलब्धि के बारे में नहीं है, बल्कि दूसरों की सहायता करने के बारे में भी है।",
        "lifeLessons": [
          { "title": "Knowledge Sharing", "description": "ज्ञान साझा करना: जो आपने सीखा है, उसे दूसरों की मदद से साझा करना दोस्ती को मजबूत और आत्म-विश्वास को बढ़ा सकता है।" },
          { "title": "Support", "description": "समर्थन: दोस्तों की मदद से उनकी क्षमताओं और आत्म-सम्मान को बढ़ाया जा सकता है।" },
          { "title": "Pride", "description": "गर्व: अपनी प्रगति पर गर्व महसूस करना दूसरों की सहायता करने के लिए प्रेरित कर सकता है।" }
        ],
        "questions": [
          {
            "id": 1,
            "text": "सैमी गिलहरी को उसके शिक्षक की मदद से बहुत कुछ सीखने को मिला। आपके शिक्षक ने स्कूल के विषयों में आपकी मदद कैसे की है?",
            "options": [
              { "value": "A", "text": "उन्होंने मेरी मदद नहीं की।" },
              { "value": "B", "text": "उन्होंने स्पष्ट रूप से समझाया।" },
              { "value": "C", "text": "उन्होंने मेरी मदद की और मुझे उत्साहित किया।" },
              { "value": "D", "text": "उन्होंने मेरी मदद नहीं की और मुझे असंतुष्ट महसूस कराया।" }
            ]
          },
          {
            "id": 2,
            "text": "सैमी नई चीजें सीखते समय आत्म-विश्वास महसूस करता है। क्या आपको सेंटर पर नई चीजें सीखने से अधिक आत्म-विश्वास मिलता है?",
            "options": [
              { "value": "A", "text": "नहीं, मुझे आत्म-विश्वास नहीं मिलता।" },
              { "value": "B", "text": "हाँ, मुझे अधिक आत्म-विश्वास मिलता है।" },
              { "value": "C", "text": "मैं वैसे ही महसूस करता हूँ।" },
              { "value": "D", "text": "मुझे नहीं पता।" }
            ]
          },
          {
            "id": 3,
            "text": "सैमी को शैक्षिक खेल खेलना पसंद है। सेंटर पर आपका पसंदीदा खेल क्या है और यह कैसे आपकी मदद करता है?",
            "options": [
              { "value": "A", "text": "मैंने कोई खेल नहीं खेला।" },
              { "value": "B", "text": "मेरा पसंदीदा खेल गणित का खेल है क्योंकि यह मजेदार है।" },
              { "value": "C", "text": "मेरा पसंदीदा खेल एक कहानी की किताब है।" },
              { "value": "D", "text": "मेरा पसंदीदा खेल एक चित्रात्मक गतिविधि है।" }
            ]
          },
          {
            "id": 4,
            "text": "सैमी हर दिन लेखन और पढ़ाई का अभ्यास करता है। सेंटर पर पढ़ाई और लेखन के लिए संसाधन आपकी कैसे मदद करते हैं?",
            "options": [
              { "value": "A", "text": "वे मेरी मदद नहीं करते।" },
              { "value": "B", "text": "वे मेरी मदद करते हैं और मुझे बेहतर महसूस कराते हैं।" },
              { "value": "C", "text": "वे मुझे भ्रमित करते हैं।" },
              { "value": "D", "text": "वे मेरे लिए अव्यवस्थित हैं।" }
            ]
          },
          {
            "id": 5,
            "text": "सैमी अपनी नई क्षमताओं को साझा करने में उत्साहित होता है। क्या आपने सेंटर पर कुछ नया सीखा है जो आपने अपने परिवार या दोस्तों के साथ साझा किया है?",
            "options": [
              { "value": "A", "text": "नहीं, मैंने कुछ नया नहीं सीखा।" },
              { "value": "B", "text": "हाँ, मैंने कुछ नया सीखा और साझा किया।" },
              { "value": "C", "text": "हाँ, लेकिन मैं साझा नहीं करता।" },
              { "value": "D", "text": "नहीं, मैंने साझा नहीं किया।" }
            ]
          },
          {
            "id": 6,
            "text": "सैमी के शिक्षक उसे कठिन विषयों में मदद करते हैं। आपका शिक्षक कठिन विषयों को आपके लिए आसान कैसे बनाता है?",
            "options": [
              { "value": "A", "text": "वे अनदेखा करते हैं।" },
              { "value": "B", "text": "वे स्पष्ट रूप से समझाते हैं।" },
              { "value": "C", "text": "वे इसे और कठिन बना देते हैं।" },
              { "value": "D", "text": "वे मुझे बुरा महसूस कराते हैं।" }
            ]
          },
          {
            "id": 7,
            "text": "सैमी विभिन्न विषयों के लिए विशेष किट्स का उपयोग करता है। क्या आपने किसी विशेष किट का उपयोग किया है और इससे आपकी समझ कैसे बेहतर हुई है?",
            "options": [
              { "value": "A", "text": "नहीं, मैंने कोई किट नहीं इस्तेमाल की।" },
              { "value": "B", "text": "हाँ, और इससे मेरी समझ बेहतर हुई।" },
              { "value": "C", "text": "हाँ, लेकिन इससे मदद नहीं मिली।" },
              { "value": "D", "text": "नहीं, किट्स उपयोगी नहीं थीं।" }
            ]
          },
          {
            "id": 8,
            "text": "सैमी अपनी प्रगति पर गर्व महसूस करता है। सेंटर पर आप किस चीज़ पर गर्व महसूस करते हैं?",
            "options": [
              { "value": "A", "text": "मैंने कुछ भी नहीं सीखा।" },
              { "value": "B", "text": "मैं पढ़ाई में सुधार पर गर्व महसूस करता हूँ।" },
              { "value": "C", "text": "मैं अपनी खेल-कूद में सुधार पर गर्व महसूस करता हूँ।" },
              { "value": "D", "text": "मैं अन्य गतिविधियों में सुधार पर गर्व महसूस करता हूँ।" }
            ]
          },
          {
            "id": 9,
            "text": "सैमी का अध्ययन स्थान सीखने के लिए उपयुक्त है। सेंटर या घर पर आपका अध्ययन स्थान कैसा है?",
            "options": [
              { "value": "A", "text": "यह शोरगुल वाला है।" },
              { "value": "B", "text": "यह शांत और उपयुक्त है।" },
              { "value": "C", "text": "यह असंगठित है।" },
              { "value": "D", "text": "यह विचलित करने वाला है।" }
            ]
          },
          {
            "id": 10,
            "text": "सैमी को होमवर्क में मदद मिलती है। सेंटर पर आपको होमवर्क में कैसे मदद मिलती है?",
            "options": [
              { "value": "A", "text": "मुझे कोई मदद नहीं मिलती।" },
              { "value": "B", "text": "मुझे शिक्षक से मदद मिलती है।" },
              { "value": "C", "text": "मुझे साथी छात्रों से मदद मिलती है।" },
              { "value": "D", "text": "मुझे अपनी खुद की मदद करनी पड़ती है।" }
            ]
          }
        ]
      },
      {
        "setNumber": 4,
        "title": "Community and Environment",
        "story": "एला नाम की हाथी को अपने लर्निंग सेंटर से बहुत प्यार था क्योंकि वहां उसे एक विशेष वातावरण मिलता था जहां वह सीख सकती थी और खेल सकती थी। उसे डिजिटल टूल्स का उपयोग करना और दोस्तों के साथ समूह परियोजनाओं पर काम करना बहुत पसंद था। एला ने अपने शिक्षक की सराहना की जिन्होंने उसे पढ़ाई और लेखन कौशल विकसित करने में मदद की। एक दिन, एला ने देखा कि उसके दोस्त, मैक्स बंदर, समूह परियोजना को समझने में असमर्थ महसूस कर रहा था। एला ने मैक्स की समस्या को देखा और उसे अपने गतिविधियों में शामिल करने का निर्णय लिया। उसने डिजिटल टूल्स और समूह सहयोग का उपयोग करके मैक्स की मदद की। एला के इस सहयोग ने मैक्स को मूल्यवान महसूस कराया और टीम का हिस्सा बना दिया। एला ने समझा कि एक सहायक और समावेशी वातावरण बनाना सभी के लिए फायदेमंद होता है और समुदाय को मजबूत करता है।",
        "lifeLessons": [
          { "title": "Inclusiveness", "description": "संघर्ष कर रहे दोस्तों को शामिल करना एक मजबूत और सहायक समुदाय बनाता है।" },
          { "title": "Collaboration", "description": "परियोजनाओं पर एक साथ काम करने से सीखने में वृद्धि होती है और एकता की भावना बनती है।" },
          { "title": "Empathy", "description": "दूसरों के सीखने के अनुभव को समझना और समर्थन देना रिश्तों को मजबूत करता है।" }
        ],
        "questions": [
          {
            "id": 1,
            "text": "एला हाथी अपने दोस्तों को पढ़ाई में मदद करती है। आप अपने दोस्तों की स्कूलवर्क में कैसे मदद करते हैं?",
            "options": [
              { "value": "A", "text": "मैं उनकी मदद नहीं करता।" },
              { "value": "B", "text": "मैं उनकी मदद करता हूँ और उन्हें सुझाव देता हूँ।" },
              { "value": "C", "text": "मैं केवल उनके काम को देखता हूँ।" },
              { "value": "D", "text": "मैं उनके साथ खेलता हूँ लेकिन पढ़ाई में नहीं।" }
            ]
          },
          {
            "id": 2,
            "text": "एला और उसके दोस्त अक्सर सेंटर पर जाते हैं। आप कितनी बार सेंटर पर जाते हैं, और वहाँ क्या सबसे अच्छा लगता है?",
            "options": [
              { "value": "A", "text": "कभी नहीं जाता।" },
              { "value": "B", "text": "कभी-कभी जाता हूँ और मुझे वहाँ पढ़ाई पसंद है।" },
              { "value": "C", "text": "हर दिन जाता हूँ और खेलकूद पसंद है।" },
              { "value": "D", "text": "बहुत कम जाता हूँ।" }
            ]
          },
          {
            "id": 3,
            "text": "एला विशेष कमरे में सीखती और खेलती है। सेंटर पर आपका समय घर से कैसे अलग है?",
            "options": [
              { "value": "A", "text": "यह अधिक शोरगुल है।" },
              { "value": "B", "text": "यह अधिक ध्यान भंग करने वाला है।" },
              { "value": "C", "text": "यह शांत और केंद्रित है।" },
              { "value": "D", "text": "यह कम संगठित है।" }
            ]
          },
          {
            "id": 4,
            "text": "एला डिजिटल टूल्स का उपयोग करती है। क्या आपने सेंटर पर कोई कंप्यूटर या टैबलेट का उपयोग किया है? यह आपकी कैसे मदद करता है?",
            "options": [
              { "value": "A", "text": "नहीं, मैंने इसका उपयोग नहीं किया।" },
              { "value": "B", "text": "हाँ, और यह मेरी मदद करता है।" },
              { "value": "C", "text": "हाँ, लेकिन यह भ्रमित करता है।" },
              { "value": "D", "text": "नहीं, यह उपयोगी नहीं था।" }
            ]
          },
          {
            "id": 5,
            "text": "एला के शिक्षक उसे पढ़ाई और लेखन में मदद करते हैं। सेंटर पर आपको इन क्षमताओं में कैसे मदद मिलती है?",
            "options": [
              { "value": "A", "text": "मुझे कोई मदद नहीं मिलती।" },
              { "value": "B", "text": "मुझे शिक्षक से मदद मिलती है।" },
              { "value": "C", "text": "मुझे डिजिटल टूल्स से मदद मिलती है।" },
              { "value": "D", "text": "मुझे साथी छात्रों से मदद मिलती है।" }
            ]
          },
          {
            "id": 6,
            "text": "एला और उसके दोस्त समूह परियोजनाओं पर काम करते हैं। क्या आप सेंटर पर कोई समूह परियोजनाओं पर काम करते हैं? आपको इनमें क्या अच्छा लगता है?",
            "options": [
              { "value": "A", "text": "नहीं, मैं समूह परियोजनाओं पर काम नहीं करता।" },
              { "value": "B", "text": "हाँ, और मुझे सहयोग करना अच्छा लगता है।" },
              { "value": "C", "text": "हाँ, लेकिन मुझे कठिनाई होती है।" },
              { "value": "D", "text": "हाँ, लेकिन मुझे काम में रुचि नहीं है।" }
            ]
          },
          {
            "id": 7,
            "text": "एला नई चीजें सीखने में खुशी महसूस करती है। सेंटर पर नई चीजें सीखने से आपको कैसे खुशी मिलती है?",
            "options": [
              { "value": "A", "text": "मुझे खुशी नहीं मिलती।" },
              { "value": "B", "text": "मुझे सीखने में मजा आता है।" },
              { "value": "C", "text": "मुझे सीखने में कठिनाई होती है।" },
              { "value": "D", "text": "मुझे नहीं पता।" }
            ]
          },
          {
            "id": 8,
            "text": "एला को उसके शिक्षक से पढ़ाई में मदद मिलती है। आपका शिक्षक आपकी पाठों को बेहतर समझने में कैसे मदद करता है?",
            "options": [
              { "value": "A", "text": "वह असहाय है।" },
              { "value": "B", "text": "वह स्पष्टता से समझाता है।" },
              { "value": "C", "text": "वह मुझे डांटता है।" },
              { "value": "D", "text": "वह केवल अपने तरीके से सिखाता है।" }
            ]
          },
          {
            "id": 9,
            "text": "एला शैक्षिक खेल खेलती है। सेंटर पर आपका पसंदीदा खेल या गतिविधि क्या है?",
            "options": [
              { "value": "A", "text": "मुझे कोई खेल पसंद नहीं है।" },
              { "value": "B", "text": "मुझे गणित का खेल पसंद है।" },
              { "value": "C", "text": "मुझे कहानी सुनना पसंद है।" },
              { "value": "D", "text": "मुझे चित्र बनाना पसंद है।" }
            ]
          },
          {
            "id": 10,
            "text": "एला का सेंटर एक विशेष जगह है। आपके लिए सेंटर को विशेष बनाने वाली एक बात क्या है?",
            "options": [
              { "value": "A", "text": "यह बहुत भीड़भाड़ वाला है।" },
              { "value": "B", "text": "यह शांति और ध्यान का माहौल प्रदान करता है।" },
              { "value": "C", "text": "यहाँ संसाधनों की कमी है।" },
              { "value": "D", "text": "यहाँ की गतिविधियाँ बहुत रुचिकर नहीं हैं।" }
            ]
          }
        ]
      },
      {
        "setNumber": 5,
        "title": "Future Aspirations and Feedback",
        "story": "टॉमी कछुआ के बड़े सपने थे और वह एक महान छात्र बनने के लिए दृढ़ संकल्पित था। उसने सेंटर के संसाधनों का उपयोग करके नई चीजें सीखीं और अपनी प्रगति को लेकर उत्साहित महसूस किया। टॉमी के पास एक शांत जगह थी जहां वह पढ़ाई करना पसंद करता था और अपने परिवार के साथ साझा करने के लिए दिलचस्प चीजें सीखा करता था। एक दिन, टॉमी की छोटी बहन, लिली भेड़, एक विषय के बारे में अधिक जानना चाहती थी लेकिन उसे overwhelmed महसूस हो रहा था। टॉमी ने याद किया कि सेंटर के संसाधनों ने उसकी कैसे मदद की और लिली की सहायता करने का निर्णय लिया। उसने एक मजेदार अध्ययन योजना बनाई और अपनी पसंदीदा किताबों का उपयोग किया ताकि लिली को सीखने में आनंद आए। लिली की नई खोजी गई उत्सुकता ने टॉमी को गर्व महसूस कराया और उसने सीखा कि अपने परिवार के साथ ज्ञान साझा करना कितना महत्वपूर्ण होता है।",
        "lifeLessons": [
          { "title": "Mentorship", "description": "परिवार के सदस्यों की मदद करने से शिक्षा के प्रति प्यार बढ़ता है और रिश्ते मजबूत होते हैं।" },
          { "title": "Sharing Knowledge", "description": "जो आपने सीखा है, उसे दूसरों की मदद करने में उपयोग करना शिक्षा के मूल्य को दर्शाता है।" },
          { "titlec": "Support", "description": "दूसरों को प्रोत्साहित और समर्थन देना उनके सफलता और खुशी में योगदान करता है।" }
        ],
        "questions": [
          {
            "id": 1,
            "text": "टॉमी कछुआ महान छात्र बनने का सपना देखता है। आपके भविष्य के सपने क्या हैं, और आप कैसे सोचते हैं कि सेंटर आपको वहां पहुंचने में मदद करता है?",
            "options": [
              { "value": "A", "text": "मुझे अपने भविष्य के बारे में नहीं पता।" },
              { "value": "B", "text": "मुझे लगता है कि सेंटर मेरी मदद करता है।" },
              { "value": "C", "text": "मुझे लगता है कि सेंटर का कोई प्रभाव नहीं है।" },
              { "value": "D", "text": "मैं इसे लेकर संकोचित हूँ।" }
            ]
          },
          {
            "id": 2,
            "text": "टॉमी सेंटर के संसाधनों का उपयोग करके नई चीजें सीखता है। सेंटर पर आपने जो नई चीजें सीखी हैं, उनमें से कौन सी आपको उत्साहित करती है?",
            "options": [
              { "value": "A", "text": "मैं कोई नई चीजें नहीं सीख पाया।" },
              { "value": "B", "text": "मैंने नई चीजें सीखी हैं और मुझे खुशी है।" },
              { "value": "C", "text": "मैंने नई चीजें सीखी हैं लेकिन मुझे खुशी नहीं है।" },
              { "value": "D", "text": "मुझे पता नहीं है।" }
            ]
          },
          {
            "id": 3,
            "text": "टॉमी को स्कूलवर्क में मदद मिलती है। आप क्या एक चीज हैं जिस पर आप चाहते हैं कि आपका शिक्षक और अधिक मदद करे?",
            "options": [
              { "value": "A", "text": "कठिन विषयों में।" },
              { "value": "B", "text": "लेखन में।" },
              { "value": "C", "text": "गणित में।" },
              { "value": "D", "text": "विज्ञान में।" }
            ]
          },
          {
            "id": 4,
            "text": "टॉमी अपने दोस्तों के साथ खेलना पसंद करता है। दोस्तों के साथ सीखने से आपको कैसा महसूस होता है?",
            "options": [
              { "value": "A", "text": "बोरिंग।" },
              { "value": "B", "text": "मजेदार।" },
              { "value": "C", "text": "कठिन।" },
              { "value": "D", "text": "निराशाजनक।" }
            ]
          },
          {
            "id": 5,
            "text": "टॉमी के सेंटर में मजेदार गतिविधियाँ हैं। सेंटर पर आपकी पसंदीदा गतिविधि या खेल क्या है?",
            "options": [
              { "value": "A", "text": "कोई विशेष पसंद नहीं।" },
              { "value": "B", "text": "गणित का खेल।" },
              { "value": "C", "text": "कला और शिल्प।" },
              { "value": "D", "text": "खेल-कूद।" }
            ]
          },
          {
            "id": 6,
            "text": "टॉमी के सेंटर में बहुत सारी किताबें और संसाधन हैं। आपकी पसंदीदा किताब या संसाधन क्या है और क्यों?",
            "options": [
              { "value": "A", "text": "मुझे कोई पसंदीदा किताब नहीं है।" },
              { "value": "B", "text": "मुझे गणित की किताब पसंद है।" },
              { "value": "C", "text": "मुझे विज्ञान की किताब पसंद है।" },
              { "value": "D", "text": "मुझे चित्रकला की किताब पसंद है।" }
            ]
          },
          {
            "id": 7,
            "text": "टॉमी को नई चीजें सीखने पर खुशी होती है। सेंटर में सीखने से आपको क्या खुशी मिलती है?",
            "options": [
              { "value": "A", "text": "मुझे खुशी नहीं मिलती।" },
              { "value": "B", "text": "मुझे सीखने में मजा आता है।" },
              { "value": "C", "text": "मुझे कठिनाई होती है।" },
              { "value": "D", "text": "मुझे नहीं पता।" }
            ]
          },
          {
            "id": 8,
            "text": "टॉमी और उसके दोस्त एक शांत जगह पर अध्ययन करते हैं। क्या आपके पास सेंटर या घर पर अध्ययन करने के लिए एक शांत स्थान है?",
            "options": [
              { "value": "A", "text": "नहीं।" },
              { "value": "B", "text": "हाँ, मुझे एक शांत स्थान मिलता है।" },
              { "value": "C", "text": "घर पर तो नहीं लेकिन सेंटर पर।" },
              { "value": "D", "text": "दोनों जगहों पर नहीं।" }
            ]
          },
          {
            "id": 9,
            "text": "टॉमी जो कुछ भी सीखता है, वह अपने परिवार के साथ साझा करता है। आपने सेंटर से कुछ दिलचस्प चीजें अपने परिवार के साथ साझा की हैं?",
            "options": [
              { "value": "A", "text": "नहीं, मैंने साझा नहीं किया।" },
              { "value": "B", "text": "हाँ, और वे खुश हुए।" },
              { "value": "C", "text": "हाँ, लेकिन मुझे नहीं पता कि वे खुश हुए या नहीं।" },
              { "value": "D", "text": "नहीं, मैंने साझा नहीं किया।" }
            ]
          },
          {
            "id": 10,
            "text": "टॉमी को लगता है कि सेंटर एक शानदार जगह है। एक बात क्या है जो सेंटर को और बेहतर बना सकती है?",
            "options": [
              { "value": "A", "text": "अधिक गतिविधियाँ।" },
              { "value": "B", "text": "अधिक किताबें।" },
              { "value": "C", "text": "एक बेहतर माहौल।" },
              { "value": "D", "text": "अधिक संसाधन।" }
            ]
          }
        ]
      }
      
      
      
      
      
]